<ng-template #passwordModal>
  <div class="modal-body overflow-auto">
    <button
      type="button"
      class="close pull-right"
      aria-label="Close"
      (click)="closeModal()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
    <!-- Start -->
    <div class="animate fadeIn password-modal-container">
      <img src="assets/img/password-reset-modal.png" />

      <h4 class="message text-center">
        Créez un mot de passe<br />
        @if (simulation) {
          <span class="message">
            pour
            <span class="message highlight">accéder à votre simulation</span>
          </span>
        } @else {
          avant de continuer
        }
      </h4>

      <form
        class="password-form form-horizontal"
        [formGroup]="form"
        (ngSubmit)="onSubmit()"
        autocomplete="off"
      >
        <div class="form-group">
          <div class="input-label">
            Saisissez votre mot de passe
            <pr-tooltip-icon
              [tooltip]="
                'Le mot de passe doit contenir au moins 12 caractères, une majuscule, une minuscule et un caractère spécial.'
              "
              width="14"
            >
            </pr-tooltip-icon>
          </div>
          <input
            type="password"
            [formControl]="form.controls['password']"
            class="form-control login-input"
            [ngClass]="{ error: passwordError() }"
          />
          @if (passwordError()) {
            <div class="error-message">
              @for (error of form.errors?.passwordErrors; track error) {
                <div class="error-message">
                  {{ error }}
                </div>
              }
            </div>
          }
        </div>

        <div class="form-group">
          <div class="input-label">Confirmez votre mot de passe</div>
          <input
            type="password"
            [formControl]="form.controls['passwordconfirm']"
            class="form-control login-input"
            [ngClass]="{ error: passwordConfirmationError() }"
          />
          @if (passwordConfirmationError()) {
            <div class="error-message">
              Les mots de passe ne correspondent pas
            </div>
          }
        </div>

        <button type="submit" class="btn btn-primary btn-round submit-button">
          J'accède à mon résultat
          @if (submitting) {
            <i class="fa fa-spinner fa-spin"></i>
          }
        </button>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #not_a_simulation> avant de continuer </ng-template>
